
import { jsPDF } from "jspdf";
import "resource/font/THSarabun-normal"
import "resource/font/THSarabun-bold"
import "../../resource/NotoSansSC-normal"
import dayjs from "dayjs";
// import companyLogo from "branch/resource/company-logo.png"
import { branchNoText } from "utils/branchNoText";
import { printHeader } from "branch/functions/pirntHeader";
import { printTable } from "utils/printTable";
import { printBankAccount, printBNColumns, lang } from "./columns";
import { addSumRow } from "utils/highlightSumColor";

export const printBillingNote365 = ({ bnData, companyData }) => {

  console.log("bnData", bnData);
  const pageSize = [8.3, 11.7]; //A4
  // const defaultHeaderSize = 20;
  // const comapanyAddrSize = 10;
  const contentSize = 12;
  const startY = 0.2
  const startX = 0.4
  // const logoWidth = 0.85
  // const logoHeight = 0.85
  const lineHeight = 0.2
  const addrBoxW = 5
  const addrBoxH = 1.1
  const dateBoxW = 2
  const dateBoxH = 0.5

  const addrDateGap = 3.5
  const dateStartX = startX + addrBoxW + addrDateGap

  const doc = new jsPDF({
    orientation: "lanscape",
    unit: "in",
    format: pageSize
  });

  let isNoWht = false
  if (bnData.CusSNm.startsWith("GENTLE") || bnData.CusSNm.startsWith("GLOBAL") || bnData.CusSNm.startsWith("ASIA")) {
    isNoWht = true
  }

  const firstInv = bnData.Invs[0]
  const isUseLITColumn = [4, 5, 9].includes(firstInv.ShpmTypId)

  const dataTable = bnData.Invs.map((item, index) => ({
    ...item,
    No: index + 1,
    id: item.InvId,
    ContNo: item.NumJobOrd > 1 ? `จำนวน ${item.NumJobOrd} เที่ยว` : item.ContNo || "",
    WhtPr1Total: isNoWht ? 0 : item.WhtPr1Total,
    WhtPr3Total: isNoWht ? 0 : item.WhtPr3Total,
    PayAmnt: isNoWht ? +item.GrandTotal : +item.GrandTotal - (item.WhtPr1Total || 0) - (item.WhtPr3Total || 0),
    TotalTrans: item.TransAmntTotal,
    TotalCharge: item.ChrgAmntTotal,
    TotalAdv: item.CusRcptAmntTotal,
    Brnd:  item.Brnd || item.Vssl ,
    CusInvNo: item.CusInvNo || item.ShRef1 || "",
  }))


  const addedTable = addSumRow({
    dataTable: dataTable,
    sumColNms: ["TotalTrans", "TotalCharge", "TotalAdv", "GrandTotal", "WhtPr1Total", "WhtPr3Total", "PayAmnt"],
    sumColTotal: "ContNo"
  })

  const finalTable = []
  doc.setFontSize(10)
  if (bnData.Lang === "TH") {
      doc.setFont("THSarabun", "normal")
    }
    else {
      doc.setFont("NotoSansSC", "normal")
    }
    
    let invNoCol = printBNColumns.find(col => col.field === "InvNo")
    let brndCol = printBNColumns.find(col => col.field === "Brnd")
    let litColumns = printBNColumns.filter(col => col.field !== "InvNo").map(col => ({ ...col }))
    litColumns.find(col => col.field === "CusInv").printWidth += invNoCol.printWidth - 0.3
    litColumns.find(col => col.field === "Loc").printWidth += 0.3
    const litColumnsChinese = litColumns.map(col => {
      return {
        ...col,
        headerName: lang[col.field]?.CN || col.headerName,
        printHeaderName: lang[col.field]?.CN || col.headerName,
      }
    })

    let normalColumns = printBNColumns.filter(col => !["ETA", "Brnd"].includes(col.field)).map(col => ({ ...col }))
    normalColumns.find(col => col.field === "CusInv").printWidth += brndCol.printWidth
    normalColumns.find(col => col.field === "CmdyTyp").printWidth += 0.2
    normalColumns.find(col => col.field === "Loc").printWidth += 0.3
    const etdCol = normalColumns.find(col => col.field === "ETD")
    etdCol.field = "InvDte"
    etdCol.headerName = "Invoice Date"
    etdCol.printWidth = 0.6
    etdCol.printFormat = "DD/MM/YYYY"
    const noCol = normalColumns.find(col => col.field === "No")
    noCol.printWidth += 0.1
    const payAmntCol = normalColumns.find(col => col.field === "PayAmnt")
    payAmntCol.printWidth += 0.1

    const printColumns = isUseLITColumn ? (bnData.Lang === "TH" ? litColumns : litColumnsChinese) : normalColumns
    const colBrndsWidth = printColumns.find(col => col.field === "Brnd")?.printWidth || 1.2
    const colLocsWidth = printColumns.find(col => col.field === "Loc")?.printWidth || 1.9
    const colCusInvWidth = printColumns.find(col => col.field === "CusInv")?.printWidth || (isUseLITColumn?1.6:2)
  for (const row of addedTable) {
    const brnds = doc.splitTextToSize(row.Brnd, colBrndsWidth)
    const locs = doc.splitTextToSize(row.Loc, colLocsWidth)
    const cusInvs = doc.splitTextToSize(row.CusInv, colCusInvWidth)
    const maxRow = Math.max(brnds.length, locs.length, cusInvs.length)
    console.log("row::", row, brnds, locs, cusInvs);
    if (brnds.length === 1 && locs.length === 1 && cusInvs.length === 1) {
      finalTable.push(row)
    } else {
      for (let i = 0; i < maxRow; i++) {

        if (i === 0) {
          finalTable.push({
            ...row,
            Brnd: brnds[i],
            Loc: locs[i],
            CusInv: cusInvs[i],
          })
        } else {
          finalTable.push({
            No: null,
            InvDte: null,
            ETA: null,
            ETD: null,
            CusInv: cusInvs[i] || "",
            CmdyTyp: "",
            Loc: locs[i] || "",
            Brnd: brnds[i] || "",
            LicNm: "",
            Port: "",
            ContNo: "",
            TotalTrans: null,
            TotalCharge: null,
            TotalAdv: null,
            GrandTotal: null,
            WhtPr1Total: null,
            WhtPr3Total: null,
            PayAmnt: null,
          })
        }
      }
    }
  }

  const MAX_LINE_PER_PAGE = 16
  const totalPage = Math.ceil(finalTable.length / MAX_LINE_PER_PAGE)
  let pageNo = 1

  do {
    if (pageNo !== 1) {
      doc.addPage(pageSize, "lanscape")
    }

    let yPos = startY
    let xPos = startX
    doc.setFont("THSarabun", "bold")
    doc.setFontSize(22)
    doc.text("ใบวางบิล\n(Billing Note)", 10, 0.83, { align: "center" })

    yPos = printHeader({ jsPDFDoc: doc, companyData, startX: xPos, startY: yPos })

    yPos += lineHeight
    let yDatePos = yPos
    doc.setLineWidth(0.01)
    doc.lines([[addrBoxW, 0], [0, addrBoxH], [addrBoxW * -1, 0], [0, addrBoxH * -1]], startX, yPos, [1, 1], 'S', true)
    yPos += lineHeight
    doc.setFont("THSarabun", "normal")
    doc.setFontSize(contentSize)
    const addrStartx = startX + 0.2
    const addrDatax = addrStartx + 0.4
    doc.text("ลูกค้า", addrStartx, yPos)
    doc.text(bnData.BillNm, addrDatax, yPos)
    yPos += lineHeight
    doc.text("ที่อยู่", addrStartx, yPos)

    const addrs = doc.splitTextToSize(bnData.BillAddr, 4.4)
    doc.text(addrs.join("\n"), addrDatax, yPos)
    // doc.text(bnData.BillAddr, addrDatax, yPos)
    yPos += lineHeight + lineHeight + lineHeight
    doc.text("เลขประจำตัวผู้เสียภาษี", addrStartx, yPos)
    doc.text(`${bnData.BillTaxId} ${branchNoText(bnData.BillNm, bnData.BillBrchNo)}`, addrDatax + 0.8, yPos)
    yPos += lineHeight

    //--------------------------------------- Box Date -----------------------------------------------------------
    doc.setFillColor("#cce6ff")
    doc.lines([[dateBoxW, 0], [0, dateBoxH / 2], [dateBoxW * -1, 0], [0, dateBoxH / 2 * -1]], dateStartX, yDatePos, [1, 1], 'DF', true)
    doc.text("Date", dateStartX + dateBoxW / 2, yDatePos + 0.18, { align: "center" })
    yDatePos += dateBoxH / 2
    doc.lines([[dateBoxW, 0], [0, dateBoxH / 2], [dateBoxW * -1, 0], [0, dateBoxH / 2 * -1]], dateStartX, yDatePos, [1, 1], 'S', true)
    doc.text(dayjs(bnData.BNDte).format("DD/MM/YYYY"), dateStartX + dateBoxW / 2, yDatePos + 0.18, { align: "center" })

    yDatePos += dateBoxH / 2 + 0.1
    doc.setFillColor("#cce6ff")
    doc.lines([[dateBoxW, 0], [0, dateBoxH / 2], [dateBoxW * -1, 0], [0, dateBoxH / 2 * -1]], dateStartX, yDatePos, [1, 1], 'DF', true)
    doc.text("Billing Note No.", dateStartX + dateBoxW / 2, yDatePos + 0.18, { align: "center" })
    yDatePos += dateBoxH / 2
    doc.lines([[dateBoxW, 0], [0, dateBoxH / 2], [dateBoxW * -1, 0], [0, dateBoxH / 2 * -1]], dateStartX, yDatePos, [1, 1], 'S', true)
    doc.text(bnData.BNNo, dateStartX + dateBoxW / 2, yDatePos + 0.18, { align: "center" })

    if (totalPage > 1) {
      doc.setFontSize(13)
      doc.setFont("THSarabun", "bold")
      doc.text(`PAGE (${pageNo}/${totalPage})`, 10, yDatePos + 0.4, { align: "center" })
      doc.setFont("THSarabun", "normal")
    }

    let totalLIT = 0
    let whtLIT = 0
    // let wthPr1 = 0
    // let wthPr3 = 0
    // let totalAdv = 0
    // let totalTrans = 0
    // let totalCharge = 0
    for (const data of bnData.Exps) {
      if (data.IsOwnRcpt === 1) {
        if (data.WhtPrct) {
          whtLIT += +data.WhtPr
          // if (data.WhtPrct === 1) {
          //   wthPr1 += +data.WhtPr
          // } else {
          //   wthPr3 += +data.WhtPr
          // }
        }
        // if (data.WhtVatPrct > 0) {
        //   totalCharge += +data.Total
        // } else {
        //   totalTrans += +data.Total
        // }
      } else {
        // totalAdv += +data.Total
      }
      totalLIT += +data.Total
    }
    let total365 = 0
    let wht365 = 0
    for (const data of bnData.Exps365) {
      if (data.IsOwnRcpt === 1) {

        if (data.WhtPrct) {
          wht365 += +data.WhtPr
          // if (data.WhtPrct === 1) {
          //   wthPr1 += +data.WhtPr
          // } else {
          //   wthPr3 += +data.WhtPr
          // }
        }

        // if (data.WhtVatPrct > 0) {
        //   totalCharge += +data.Total
        // } else {
        //   totalTrans += +data.Total
        // }
      } else {
        // totalAdv += +data.Total
      }
      total365 += +data.Total
    }

    const startTableX = startX - 0.2

    if (bnData.Lang === "TH") {
      doc.setFont("THSarabun", "normal")
    }
    else {
      doc.setFont("NotoSansSC", "normal")
    }


    const pagedTable = finalTable.slice((pageNo - 1) * MAX_LINE_PER_PAGE, pageNo * MAX_LINE_PER_PAGE)
    if (bnData.Invs.length > 0) {
      yPos = printTable({
        doc,
        dataTable: pagedTable,
        columns: isUseLITColumn ? bnData.Lang === "TH" ? litColumns : litColumnsChinese : normalColumns,
        startX: startTableX,
        startY: yPos,
        fontSize: bnData.Lang === "TH" ? 10 : 6
      })
    }


    if (pageNo === totalPage) {
      yPos += lineHeight * 1.5
      // doc.text("xxx", startTableX, yPos)
      // yPos += lineHeight
      // doc.setFont("NotoSansSC", "normal")
      // doc.text("商品  货物 商品 货物 ", startTableX, yPos)
      // yPos += lineHeight

      doc.setFont("THSarabun", "bold")
      doc.setFontSize(14)
      doc.text("Payment Summary", startTableX, yPos)

      doc.setFontSize(12)
      if (bnData.Lang === "TH") {
        doc.setFont("THSarabun", "normal")
      } else {
        doc.setFont("NotoSansSC", "normal")
      }

      const AccTable = []
      if (bnData.CusSNm.startsWith("GENTLE") || bnData.CusSNm.startsWith("GLOBAL") || bnData.CusSNm.startsWith("ASIA")) {
        if (bnData.CusSNm.startsWith("ASIA")) {
          AccTable.push({
            AccNm: "ASIASUP CHAROEN CO.,LTD.",
            AccNo: bnData.Lang === "TH" ? "Acc No.: 167-2-97042-5" : "Acc No./账号 167-2-97042-5",
            Bank: bnData.Lang === "TH" ? "SCB Bank" : "SCB Bank//泰国汇商银行",
            Amnt: totalLIT + total365
          })
        } else if (bnData.CusSNm.startsWith("GENTLE")) {
          AccTable.push({
            AccNm: "GENTLE FRUIT CO.,LTD.",
            AccNo: bnData.Lang === "TH" ? "Acc No.: 167-2-97029-7" : "Acc No./账号 167-2-97029-7",
            Bank: bnData.Lang === "TH" ? "SCB Bank" : "SCB Bank//泰国汇商银行",
            Amnt: totalLIT + total365
          })
        } else if (bnData.CusSNm.startsWith("GLOBAL")) {
          AccTable.push({
            AccNm: "GLOBAL FRUIT CO.,LTD.",
            AccNo: bnData.Lang === "TH" ? "Acc No.: 653-3-01368-3" : "Acc No./账号 .: 653-3-01368-3",
            Bank: bnData.Lang === "TH" ? "SCB Bank" : "SCB Bank//泰国汇商银行",
            Amnt: totalLIT + total365
          })
        }
      } else {
        if (totalLIT > 0) {
          AccTable.push({
            AccNm: "LAEMCHABANG INTER TRANS",
            AccNo: bnData.Lang === "TH" ? "Acc No.: 653-3-01211-6" : "Acc No./账号 653-3-01211-6",
            Bank: bnData.Lang === "TH" ? "SCB Bank" : "SCB Bank//泰国汇商银行",
            Amnt: totalLIT - whtLIT
          })
        }
        if (total365 > 0) {
          AccTable.push({
            AccNm: "365 WORLDWIDE",
            AccNo: bnData.Lang === "TH" ? "Acc No. 653-4-35244-6" : "Acc No./账号 653-4-35244-6",
            Bank: bnData.Lang === "TH" ? "SCB Bank" : "SCB Bank//泰国汇商银行",
            Amnt: total365 - wht365
          })
        }
      }

      yPos = printTable({
        doc,
        dataTable: AccTable,
        columns: printBankAccount,
        startX: startTableX,
        startY: yPos,
        fontSize: bnData.Lang === "TH" ? 14 : 10
      })
      yPos -= lineHeight / 2
      const accTableWidth = printBankAccount.reduce((acc, col) => acc + (col.printWidth || 0.5), 0)
      doc.line(startTableX, yPos, startTableX + accTableWidth, yPos)
    }
    pageNo++
  } while (pageNo <= totalPage)

  const blob = new Blob([doc.output('blob')], { type: 'application/pdf' });
  const blobUrl = URL.createObjectURL(blob);
  
  // Open in new tab
  window.open(blobUrl, '_blank');
  
  // Clean up memory after a small delay
  ;
}